var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RetencionesSpentPayment',{attrs:{"item":_vm.item,"isViewModal":_vm.isViewModal,"open":_vm.open,"validator":_vm.validator,"receiver":_vm.receiver,"loading_calc_retenciones":_vm.loading_calc_retenciones,"openFromPaymentOrder":true},on:{"setLoadingCalcRetenciones":_vm.handleSetLoadingCalcRetenciones}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }